/* eslint-disable @typescript-eslint/no-unused-vars */
import type {AppConfiguration} from "./app-configuration-types";
export const C: AppConfiguration = {
    package: 'cleanup',
    menu: 'hidden',
    profile: {
        locale: 'nl-nl',
        currency: 'EUR',

        p_name_col_name: 'Name',
        p_description_col_name: 'Description',
        searchConfiguration: 'default_p_desc',

        taxonomy_builder_only_n_cats: true,
        allowIncompleteTaxonomy: true,

        disableSupplierNormalizationAiModel: true,
        parentSupplierAltName: 'Normalized Supplier',
        showSupplierIdInSupplierNormalization: true,

        hideCards: [
            'koi-ppv',
            'koi-spend-concentration',
        ],
        showCards: [
            'contract-explorer',
            'payment-terms',
        ],

        enableProcChat: true,
        enableGoldenRecord: true,
        enableSavingInitiativeTracker: true,

        showSupplierIdInAdvDashboard: true,
        synergyDashboardShowBusinessUnits: true,
        synergyDashboardShowCAddressFilter: true,
        synergyDashboardShowCDescriptionFilter: true,
        showSupplierCountryInSupplierNormalization: true,
        showBusinessUnitInSupplierNormalization: true,
    },
}
